module.exports = __webpack_public_path__ + "static/media/condo_homes.7edf629a.png";